module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "New Telegram channel",
      "visible": _vm.showDialog,
      "before-close": _vm.handleClose,
      "center": true,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-telegram"
  }), _vm._v(" Telegram channel")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [_c('el-steps', {
    staticClass: "telegramSteps",
    attrs: {
      "active": _vm.activeStep,
      "align-center": "",
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Request Code"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Sign in"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Finished"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "center",
    attrs: {
      "span": 24
    }
  }, [(_vm.activeStep == 0) ? _c('p', [_vm._v("Please choose your country and enter your phone number.")]) : _vm._e(), _vm._v(" "), (_vm.activeStep == 1) ? _c('p', [_vm._v(" The login code has been sent to "), _c('strong', [_vm._v(" " + _vm._s(_vm.fullPhoneNumber))]), _vm._v(". "), _c('br'), _c('br'), _vm._v("Please enter your code below or click "), _c('a', {
    on: {
      "click": _vm.onClickChangeNumber
    }
  }, [_vm._v(" here")]), _vm._v(" to change your number.")]) : _vm._e(), _vm._v(" "), _c('br')])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [(_vm.codeRequestHasFailed || _vm.validationError) ? _c('el-alert', {
    staticClass: "alert",
    attrs: {
      "title": "Code request failed",
      "type": "error",
      "closable": false
    }
  }, [_vm._v("\n          " + _vm._s(_vm.errorMessage) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.codeRequestHasFailed || _vm.validationError) ? _c('br') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [(_vm.activeStep == 0) ? _c('el-form', {
    ref: "telegramChannelForm",
    attrs: {
      "model": _vm.telegramChannelForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "countryCode"
    }
  }, [_c('country-code-selector', {
    staticClass: "country-selector",
    attrs: {
      "selectedCountry": _vm.selectedCountry.code,
      "browserCountryCode": _vm.userCountryCode
    },
    on: {
      "onCountryChanged": _vm.handleCountryChanged
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Phone number"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phone number"
    },
    model: {
      value: (_vm.telegramChannelForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "phoneNumber", $$v)
      },
      expression: "telegramChannelForm.phoneNumber"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("\n                " + _vm._s(_vm.selectedCountry.flag) + "\n                " + _vm._s(_vm.selectedCountry.dial_code) + "\n              ")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Account status"
    }
  }, [_c('P', [_vm._v("Do you have a Telegram account?")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.existingAccount),
      callback: function($$v) {
        _vm.existingAccount = $$v
      },
      expression: "existingAccount"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Yes"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "No"
    }
  })], 1)], 1), _vm._v(" "), (_vm.existingAccount == 'No') ? _c('div', [_c('hr'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20,
      "offset": 2
    }
  }, [_c('small', [_c('p', {
    staticClass: "center"
  }, [_vm._v("Telegram requires you to add a This is what other users will see when they view your contact on Telegram,\n                    this is required by Telegram, we suggest using your station name instead.")])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "First name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "ACME"
    },
    model: {
      value: (_vm.telegramChannelForm.firstName),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "firstName", $$v)
      },
      expression: "telegramChannelForm.firstName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Last name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "FM"
    },
    model: {
      value: (_vm.telegramChannelForm.lastName),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "lastName", $$v)
      },
      expression: "telegramChannelForm.lastName"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.activeStep == 1) ? _c('el-form', {
    attrs: {
      "model": _vm.telegramChannelForm,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 18
    }
  }, [(_vm.telegramSignInError) ? _c('el-alert', {
    attrs: {
      "title": "Sign In Failed",
      "type": "error",
      "description": "The code you entered is invalid or has expired. Please try again or request a new code."
    }
  }) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Enter code here",
      "clearable": ""
    },
    model: {
      value: (_vm.telegramChannelForm.telegramCode),
      callback: function($$v) {
        _vm.$set(_vm.telegramChannelForm, "telegramCode", $$v)
      },
      expression: "telegramChannelForm.telegramCode"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTelegramCodeRequest),
      expression: "loadingTelegramCodeRequest"
    }],
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.onClickRequestCode
    },
    slot: "append"
  }, [_vm._v("Resend code")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer clearfix",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.activeStep == 0) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTelegramCodeRequest),
      expression: "loadingTelegramCodeRequest"
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onClickRequestCode
    }
  }, [_vm._v("Request code")]) : _vm._e(), _vm._v(" "), (_vm.activeStep == 1) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTelegramSignIn),
      expression: "loadingTelegramSignIn"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onClickSignIn
    }
  }, [_vm._v("Sign in")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a4e2b07","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/telegram/TelegramNewDialog.vue
// module id = 3267
// module chunks = 3